import { render } from "./office.vue?vue&type=template&id=37584c3e"
import script from "./office.vue?vue&type=script&lang=js"
export * from "./office.vue?vue&type=script&lang=js"

import "./office.vue?vue&type=style&index=0&id=37584c3e&lang=css"

import exportComponent from "/Users/aun/Development/thailand-fest/thai-festival-admin-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__